class Mv {
    constructor() {
        this.speachBubbles = document.querySelectorAll('.cmp-mv__speach-bubble');
        this.isSp = window.matchMedia("(max-width:992px)");
        
        if(this.speachBubbles) {
            this.speachBubbles.forEach(speachBubble => {
                this.event(speachBubble);
            });

        }
    }

    // ============
    // Events
    // =============
    event(speachBubble) {
        speachBubble.addEventListener('click', event => this.ActivateTargetItem( speachBubble ))
        window.addEventListener('resize', () => {
            if(!this.isSp.matches) {
                this.reset()
            }
        });
    }

    // ============
    // Methods
    // =============

    // 対象の画像の表示
    ActivateTargetItem(targetElement) {
        this.DeactivateOtherItems(targetElement);

        if(this.isSp.matches) {
            targetElement.classList.add('is-active');
        }
    }

    // 対象画像以外の画像を非表示
    DeactivateOtherItems(targetElement) {
        this.speachBubbles.forEach(speachBubble => {
            if(speachBubble !== targetElement && speachBubble.classList.contains('is-active')) {
                speachBubble.classList.remove('is-active')
            }
        })
    }

    // 処理のリセット
    reset() {
        this.speachBubbles.forEach(element => {
            element.classList.remove('is-active');
        })
    }
}

export default Mv;